import React from 'react';
import { Box, Chip, useMediaQuery } from '@mui/material';
import { Close } from '../../../components/icons';
import IconReusable from '../../../components/IconReusable';

const CustomChip = ({
  label,
  onDelete,
  variant = 'filled', // 'filled' or 'outlined'
  color = 'primary',
  deleteIcon,
  sx = {},
  size = 'default', // small || default,
  selected = false,
  ...props
}) => {
  const isMobile = useMediaQuery('(max-width: 1200px)');
  const getChipStyles = () => {
    const baseStyles = {
      borderRadius: '8px !important',
      border: 'none',
      padding: size === 'small' ? '2px 8px' : '4px 16px',
      height: size === 'small' ? '24px' : '28px',
      fontSize:  size === 'small' ? '11px' : '13px',
      lineHeight: size === 'small' ? '20px' : '20px',
      fontWeight: 600,
      transition: 'all 0.2s ease-in-out',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      '& .MuiChip-deleteIcon': {
        fontSize: size === 'small' ? '8px' : '13px',
        margin: 0,
      },
      '& .MuiChip-label': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    };

    if (variant === 'filled') {
      return {
        ...baseStyles,
        fontSize: size === 'small' ? '13px' : '16px',
        lineHeight: size === 'small' ? '20px' : '24px',
        padding: size === 'small' ? '2px 8px' : '4px 12px',
        // color: '#fff !important',
        outline: 'none',
        boxShadow: selected ? `
          0px 2px 1px -1px rgba(0, 0, 0, 0.30),
          0px 1px 1px 0px rgba(0, 0, 0, 0.20)
        ` : 'none',
        '& .MuiChip-deleteIcon': {
          ...baseStyles['& .MuiChip-deleteIcon'],
          color: selected ? '#fff !important' : '#333333 !important',
        },
        color: selected ? '#fff' : '#333333 !important',
        outline: selected ? 'none' : '1px solid #8C8C8C',
        outlineOffset: selected ? '0px' :'-1px',
        backgroundColor: selected ? '#333333 !important' : 'transparent',
      };
    }

    // outlined variant
    return {
      ...baseStyles,
      backgroundColor: 'transparent !important',
      color: selected ? '#995A00' : '#333333 !important',
      outline: selected ? '1px solid #995A00' : '1px solid #8C8C8C',
      outlineOffset: '-1px',
      '& .MuiChip-deleteIcon': {
        ...baseStyles['& .MuiChip-deleteIcon'],
        color: '#8C8C8C !important',
      },
    };
  };

  const defaultDeleteIcon = deleteIcon || (
    <Box sx={{ display:'flex', justifyContent:'center', alignItems: 'center' }}>
      <IconReusable name="Close" size={ size === 'small' ? 16 : 16 } />
    </Box>
  );

  return (
    <Chip
      label={label}
      onDelete={onDelete}
      size={size}
      variant="outlined" // Always use outlined as base, styling handles the appearance
      color={color}
      deleteIcon={defaultDeleteIcon}
      sx={{
        ...getChipStyles(),
        ...sx,
      }}
      {...props}
    />
  );
};

export default CustomChip;